module.exports = __webpack_public_path__ + "static/media/joint.9a37e48b.svg";